import request from "@/utils/request.js";

const baseUrl = '/api/authentication'

export default {

    createOrder(data) {
        return request({
            url: `/api/order/wechat/native`,
            method: 'post',
            data: data
        })
    },

    createOfflineOrder(data) {
        return request({
            url: `/api/order/offline/native`,
            method: 'post',
            data: data
        })
    },
    confirmOrder(orderNo) {
        return request({
            url: `/api/order/wechat/confirm-order?orderNo=${orderNo}`,
            method: 'post'
        })
    },

    login(data) {
        return request({
            url: `${baseUrl}/login`,
            method: 'post',
            data
        })
    },
    resetPassword(data) {
        return request({
            url: `${baseUrl}/reset-password`,
            method: 'post',
            data
        })
    },
    registerUser(data) {
        return request({
            url: `${baseUrl}/register-user`,
            method: 'post',
            data
        })
    },
    verificationCode() {
        return request({
            url: `/api/common/verification-code`,
            method: 'get'
        })
    },
    sendEmailCode(data) {
        return request({
            url: `/api/common/send-mail-code`,
            method: 'post',
            data
        })
    },
    sendSmsCode(data) {
        return request({
            url: `/api/common/send-sms-code`,
            method: 'post',
            data
        })
    },
    userAuthentication(data) {
        return request({
            url: `${baseUrl}/user-authentication`,
            method: 'post',
            data
        })
    },
    resetMobileConfirm(data) {
        return request({
            url: `${baseUrl}/reset-mobile-confirm`,
            method: 'post',
            data
        })
    },
    resetEmailConfirm(data) {
        return request({
            url: `${baseUrl}/reset-email-confirm`,
            method: 'post',
            data
        })
    },

    getUserInfo(params) {
        return request({
            url: `/api/open-user/getUserInfo`,
            method: 'get',
            headers: params.headers
        })
    },

    searchByPhone(params) {
        return request({
            url: `/api/open-user/searchByPhone`,
            method: 'get',
            headers: params.headers
        })
    },

    searchActiveByPhone(params) {
        return request({
            url: `/api/open-user/searchActiveByPhone`,
            method: 'get',
            headers: params.headers
        })
    }
    
}
